import React, { Component } from 'react';

class Team extends Component {
    constructor() {
        super();
        this.state = {
            active: Math.round(Math.random()*4)
        }
    }

    changeMember(index) {
        this.setState({ active: index })
    }

    render() {
      const { members } = this.props;
      const memberImageList = members.map((o, i) => {
          const url1 = o.images[1].imgType === "gif" ? o.images[1].url : o.images[1].url + "&w=300&h=300";
          const url0 = o.images[0].imgType === "gif" ? o.images[0].url : o.images[0].url + "&w=300&h=300";
          const style = {
            top: 100 * i + "px",
            backgroundImage: 'url('+ url1 +')',
            order: members.length - i
          }
          return <li key={i} onClick={this.changeMember.bind(this, i)} className={this.state.active === i ? "active" : ""} style={style}>
                <img className="highlight" src={url0} alt=""/>
          </li>
      });
      const memberList = members.map((o, i) => {
          return <li key={i} onClick={this.changeMember.bind(this, i)} className={this.state.active === i ? "active" : ""}>
              <h2>{o.name}</h2>
              <p>{o.role}</p>
          </li>
      });
      const memberInfoList = members.map((o, i) => {
          return <li key={i} className={this.state.active === i ? "" : "hide"}>
              <h3>{o.name}</h3>
              <p>{o.subline}</p>
              <p>{o.description}</p>
          </li>
      });
      return (
          <div id="team">
            <h1>People</h1>
            <div id="member-names"><ul>{memberList}</ul></div>
            <div id="member-images"><ul>{memberImageList}</ul></div>
            <div id="member-desc"><ul>{memberInfoList}</ul></div>
          </div>
      );
    }
}

export default Team;



// WEBPACK FOOTER //
// ./src/components/Info/Team.js